/*
  1. 导入
import TipsMark from './components/tipsMark/index'

  const [tipsStatus, setTipsStatus] = useState(false)
  const tipsComplete = () => {
    console.log('完成');

  }

<TipsMark openstatus={tipsStatus} complete={tipsComplete} />

*/
import React, { useState, useEffect, useRef } from 'react';
import './index.less';
import { useTranslation } from 'react-i18next';

export default function ScreenRecorder(props) {
  const { openstatus, complete, sysAudio } = props;
  const { t } = useTranslation('screenRecorder');
  const leftTop = useRef(null);
  const leftCenter = useRef(null);
  const leftBottom = useRef(null);
  const rightBottom = useRef(null);
  const [isShow, setIsShow] = useState(false);

  const start = () => {
    if (!openstatus) return;

    // 计算每个显示的位置
    const clientWidth = document.body.clientWidth;
    if (clientWidth < 1663) {
      setIsShow(true);
      return;
    } else {
      setIsShow(false);
    }
    const madalWidth = 608;
    const leftChooseRight = clientWidth / 2 + madalWidth / 2 + 16;

    leftTop.current.style.right = leftChooseRight + 'px';

    leftCenter.current.style.right = leftChooseRight + 'px';
    leftCenter.current.style.top = 173 + 'px';

    leftBottom.current.style.right = leftChooseRight + 'px';
    leftBottom.current.style.top = 436 + 'px';

    leftBottom.current.style.visibility = sysAudio ? 'visible' : 'hidden';

    // 1. 控制滚动条不滚动
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
  };

  const stop = () => {
    // 去除滚动
    document.documentElement.style.overflow = 'auto';
    document.body.style.position = 'static';
    complete();
  };
  useEffect(() => {
    if (openstatus) {
      start();
    } else {
      stop();
    }
  }, [openstatus]);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setIsShow(false);
      start();
    });
    return () => {
      window.removeEventListener('resize', start);
    };
  }, [document.body.clientWidth]);

  return (
    <div>
      {openstatus && (
        <div className={`tips-mark ${isShow ? 'none' : ''}`}>
          <div className='mask'></div>
          <div className='number' ref={leftTop}>
            <span className='subContent'>{t('StepOne')}</span>
            <span className='triangle'></span>
          </div>
          <div className='number' ref={leftCenter}>
            <span className='subContent'>{t('StepTwo')}</span>
            <span className='triangle'></span>
          </div>
          <div className='number' ref={leftBottom}>
            <span className='subContent'>{t('StepThree')}</span>
            <span className='triangle'></span>
          </div>

          {/* <div className="rightNumber" ref={rightBottom}>
            <span>{sysAudio?4:3}. </span> <span className="subContent">Click share to start recording</span>
            <span className="triangle1"></span>
          </div> */}
        </div>
      )}
    </div>
  );
}
